<div class="storage-settings-container">
  <div class="storage-settings-header">
    <h3>Storage Settings</h3>
    <p>Configure storage and file upload limits for this license.</p>
  </div>

  <form [formGroup]="formGroup" class="storage-settings-form">
    <!-- File Size Settings -->
    <div class="form-field">
      <label for="maxFileSizeMB" class="field-label">
        Maximum File Size (MB)
        <span class="required">*</span>
      </label>
      <p-inputnumber
        id="maxFileSizeMB"
        formControlName="maxFileSizeMB"
        [showButtons]="true"
        buttonLayout="horizontal"
        spinnerMode="horizontal"
        [step]="1"
        placeholder="Enter maximum file size in MB (1-1000)"
        class="w-full"
        [class.ng-invalid]="
          formGroup.get('maxFileSizeMB')?.invalid &&
          formGroup.get('maxFileSizeMB')?.touched
        "
        (onBlur)="
          formGroup.get('maxFileSizeMB')?.markAsTouched();
          formGroup.get('maxFileSizeMB')?.markAsDirty()
        "
        (onInput)="
          formGroup.get('maxFileSizeMB')?.markAsTouched();
          formGroup.get('maxFileSizeMB')?.markAsDirty()
        "
      ></p-inputnumber>
      <cognos-validation-message
        [control]="formGroup.get('maxFileSizeMB')"
        [customErrorMessages]="{
          required: 'Maximum file size is required',
          min: 'Maximum file size must be at least 1 MB',
          max: 'Maximum file size must be at most 1000 MB'
        }"
      ></cognos-validation-message>
    </div>

    <div class="form-actions">
      <p-button
        label="Save Settings"
        icon="pi pi-check"
        (onClick)="onSaveClick()"
        [loading]="isLoading"
        [disabled]="isSaveDisabled()"
        class="save-button"
      ></p-button>
    </div>
  </form>
</div>
